// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* progress bar */
progress {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 5px;
  border: 0;
  z-index: 100;
}

/* dwv */
.dwv {
  display: flex;
  flex-direction: column;
}
.layerGroup {
  position: relative;
  padding: 0;
  display: flex;
  justify-content: center;
  /* occupy space left by toolbar and legend */
  flex: 1;
}
.layer {
  position: absolute;
  pointer-events: none;
}

/* drag&drop */
.dropBox {
  text-align: center;
  width: 50%; height: 75%;
}
.dropBoxBorder {
  margin: 20px auto;
  border: 5px dashed #ccc;
}
.dropBoxBorder:hover {
  margin: 20px auto;
  border: 5px dashed #cc0;
}
#input-file-link {
  text-decoration-line: underline;
}

/* legend */
.legend {
  text-align: center;
  font-size: 8pt;
  margin: 1em;
}

/* toolbar */
.toolbar {
  font: 14px arial, sans-serif;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.toolbar button, .toolbar select {
  margin: 10px 3px;
  padding: 10px 10px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  color: #757575;
}
.toolbar button:enabled:hover, .toolbar select:enabled:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.toolbar button:disabled, .toolbar select:disabled {
  color: #bdbdbd;
  cursor: default;
}
.toolbar .active {
  background-color: #f0f1f9 !important;
}
.toolbar button:enabled path {
  fill: #757575;
}
.toolbar button.active:enabled path {
  fill: #4a5bb9;
}
.toolbar button:disabled path {
  fill: #bdbdbd;
}

/* modal dialog */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */

  .modal-content {
    background-color: #fefefe;
    margin: 5% auto; /* 5% from the top and centered */
    padding: 20px;
    width: 80%;
    height: 80%;
    overflow: auto;
  }

  input, label {
    vertical-align: middle;
    margin-right: 10px;
  }

  .modal-content-scroll {
    margin-right: 20px;
    height: 80%;
    overflow: auto;

    table {
      width: 100%;
      border-collapse: collapse;
    }
    tr {
      border: solid thin;
      border-color: #ddd;
    }
    th {
      text-align: left;
    }
    td, th {
      padding: 10px;
    }
  }
}

/* color-scheme */
@media (prefers-color-scheme: dark) {
  .legend a {
    color: #ccc;
  }
  .toolbar button, .toolbar select {
    border: 1px solid #2f2f2f;
    background-color: #fff;
  }
  .toolbar button, .toolbar select {
    color: #fff;
    background-color: #333;
  }
  .toolbar button:enabled:hover, .toolbar select:enabled:hover {
    background-color: #555;
  }
  .toolbar button:disabled, .toolbar select:disabled {
    color: #aeaeae;
  }
  .toolbar .active {
    background-color: #404040 !important;
  }
  .toolbar button:enabled path {
    fill: #fff;
  }
  .toolbar button:disabled path {
    fill: #aeaeae;
  }
  .modal {
    .modal-content {
      background-color: #424242;
    }
    .modal-content-scroll {
      tr {
        border: solid thin;
        border-color: #666;
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/dwv-component.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;AACzB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,sBAAsB;EACrC,eAAe,EAAE,kBAAkB;EACnC,UAAU,EAAE,eAAe;EAC3B,OAAO;EACP,MAAM;EACN,WAAW,EAAE,eAAe;EAC5B,YAAY,EAAE,gBAAgB;EAC9B,4BAA4B,EAAE,mBAAmB;EACjD,iCAAiC,EAAE,qBAAqB;;EAExD;IACE,yBAAyB;IACzB,eAAe,EAAE,iCAAiC;IAClD,aAAa;IACb,UAAU;IACV,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;;IAEd;MACE,WAAW;MACX,yBAAyB;IAC3B;IACA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,aAAa;IACf;EACF;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,oCAAoC;EACtC;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE;MACE,yBAAyB;IAC3B;IACA;MACE;QACE,kBAAkB;QAClB,kBAAkB;MACpB;IACF;EACF;AACF","sourcesContent":["/* progress bar */\nprogress {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 100%;\n  height: 5px;\n  border: 0;\n  z-index: 100;\n}\n\n/* dwv */\n.dwv {\n  display: flex;\n  flex-direction: column;\n}\n.layerGroup {\n  position: relative;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  /* occupy space left by toolbar and legend */\n  flex: 1;\n}\n.layer {\n  position: absolute;\n  pointer-events: none;\n}\n\n/* drag&drop */\n.dropBox {\n  text-align: center;\n  width: 50%; height: 75%;\n}\n.dropBoxBorder {\n  margin: 20px auto;\n  border: 5px dashed #ccc;\n}\n.dropBoxBorder:hover {\n  margin: 20px auto;\n  border: 5px dashed #cc0;\n}\n#input-file-link {\n  text-decoration-line: underline;\n}\n\n/* legend */\n.legend {\n  text-align: center;\n  font-size: 8pt;\n  margin: 1em;\n}\n\n/* toolbar */\n.toolbar {\n  font: 14px arial, sans-serif;\n  margin-bottom: 5px;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.toolbar button, .toolbar select {\n  margin: 10px 3px;\n  padding: 10px 10px;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 600;\n  height: 40px;\n  border: 1px solid #e0e0e0;\n  background-color: #fff;\n  color: #757575;\n}\n.toolbar button:enabled:hover, .toolbar select:enabled:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.toolbar button:disabled, .toolbar select:disabled {\n  color: #bdbdbd;\n  cursor: default;\n}\n.toolbar .active {\n  background-color: #f0f1f9 !important;\n}\n.toolbar button:enabled path {\n  fill: #757575;\n}\n.toolbar button.active:enabled path {\n  fill: #4a5bb9;\n}\n.toolbar button:disabled path {\n  fill: #bdbdbd;\n}\n\n/* modal dialog */\n.modal {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1; /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%; /* Full width */\n  height: 100%; /* Full height */\n  background-color: rgb(0,0,0); /* Fallback color */\n  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n\n  .modal-content {\n    background-color: #fefefe;\n    margin: 5% auto; /* 5% from the top and centered */\n    padding: 20px;\n    width: 80%;\n    height: 80%;\n    overflow: auto;\n  }\n\n  input, label {\n    vertical-align: middle;\n    margin-right: 10px;\n  }\n\n  .modal-content-scroll {\n    margin-right: 20px;\n    height: 80%;\n    overflow: auto;\n\n    table {\n      width: 100%;\n      border-collapse: collapse;\n    }\n    tr {\n      border: solid thin;\n      border-color: #ddd;\n    }\n    th {\n      text-align: left;\n    }\n    td, th {\n      padding: 10px;\n    }\n  }\n}\n\n/* color-scheme */\n@media (prefers-color-scheme: dark) {\n  .legend a {\n    color: #ccc;\n  }\n  .toolbar button, .toolbar select {\n    border: 1px solid #2f2f2f;\n    background-color: #fff;\n  }\n  .toolbar button, .toolbar select {\n    color: #fff;\n    background-color: #333;\n  }\n  .toolbar button:enabled:hover, .toolbar select:enabled:hover {\n    background-color: #555;\n  }\n  .toolbar button:disabled, .toolbar select:disabled {\n    color: #aeaeae;\n  }\n  .toolbar .active {\n    background-color: #404040 !important;\n  }\n  .toolbar button:enabled path {\n    fill: #fff;\n  }\n  .toolbar button:disabled path {\n    fill: #aeaeae;\n  }\n  .modal {\n    .modal-content {\n      background-color: #424242;\n    }\n    .modal-content-scroll {\n      tr {\n        border: solid thin;\n        border-color: #666;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
